module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("FAV")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-mask ng-valid-parse ng-valid-date ng-valid-max ng-valid ng-valid-required",
    attrs: {
      "name": "user",
      "novalidate": ""
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    attrs: {
      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fav.name),
      expression: "fav.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "favName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.fav.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fav, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (this.$root.authorize('perfil-novo')) ? _c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('fieldset', [_c('legend', [_vm._v("Cadastro de Perguntas")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$root.authorize('perfil-novo')),
      expression: "this.$root.authorize('perfil-novo')"
    }],
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atribuir")])])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "well well-sm no-shadow animated fadeInDownOutUp ng-pristine ng-valid-mask ng-invalid ng-invalid-required ng-valid-maxlength ng-valid-max ng-valid-date ng-hide"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "questionNumber"
    }
  }, [_vm._v("Número da Pergunta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questao.questionNumber),
      expression: "questao.questionNumber"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-isolate-scope ng-valid-mask ng-empty ng-valid-maxlength",
    attrs: {
      "name": "questionNumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.questao.questionNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.questao, "questionNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "local"
    }
  }, [_vm._v("Local:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questao.local),
      expression: "questao.local"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "local"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.questao, "local", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listaLocais), function(local) {
    return _c('option', {
      domProps: {
        "value": local
      }
    }, [_vm._v(_vm._s(local))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    attrs: {
      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "pergunta"
    }
  }, [_vm._v("Pergunta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questao.question),
      expression: "questao.question"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "favQuestion",
      "type": "text"
    },
    domProps: {
      "value": (_vm.questao.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.questao, "question", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "bt_conformidade"
    }
  }, [_vm._v("Respostas:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questao.conformityYes),
      expression: "questao.conformityYes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Sim"
    },
    domProps: {
      "checked": Array.isArray(_vm.questao.conformityYes) ? _vm._i(_vm.questao.conformityYes, "Sim") > -1 : (_vm.questao.conformityYes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questao.conformityYes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Sim",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.questao, "conformityYes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.questao, "conformityYes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.questao, "conformityYes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "conformityYes"
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questao.conformityNo),
      expression: "questao.conformityNo"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Não"
    },
    domProps: {
      "checked": Array.isArray(_vm.questao.conformityNo) ? _vm._i(_vm.questao.conformityNo, "Não") > -1 : (_vm.questao.conformityNo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questao.conformityNo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Não",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.questao, "conformityNo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.questao, "conformityNo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.questao, "conformityNo", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "conformityNo"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questao.conformityNA),
      expression: "questao.conformityNA"
    }],
    attrs: {
      "type": "checkbox",
      "value": "NA"
    },
    domProps: {
      "checked": Array.isArray(_vm.questao.conformityNA) ? _vm._i(_vm.questao.conformityNA, "NA") > -1 : (_vm.questao.conformityNA)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.questao.conformityNA,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "NA",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.questao, "conformityNA", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.questao, "conformityNA", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.questao, "conformityNA", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "conformityNA"
    }
  }, [_vm._v("N/A")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "items": _vm.table2.items,
      "hover": _vm.table2.hover,
      "fields": _vm.table2.fields,
      "current-page": _vm.table2.currentPage,
      "per-page": _vm.table2.perPage,
      "sort-by": _vm.table2.sortBy,
      "sort-desc": _vm.table2.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table2, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table2, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table2, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table2, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              return _vm.onEdit(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("Excluir")])], 1)]
      }
    }, {
      key: "conformityYes",
      fn: function(row) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (row.item.conformityYes),
            expression: "row.item.conformityYes"
          }],
          attrs: {
            "type": "checkbox",
            "name": "conformityYes",
            "disabled": true
          },
          domProps: {
            "checked": Array.isArray(row.item.conformityYes) ? _vm._i(row.item.conformityYes, null) > -1 : (row.item.conformityYes)
          },
          on: {
            "change": function($event) {
              var $$a = row.item.conformityYes,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(row.item, "conformityYes", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(row.item, "conformityYes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(row.item, "conformityYes", $$c)
              }
            }
          }
        })]
      }
    }, {
      key: "conformityNo",
      fn: function(row) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (row.item.conformityNo),
            expression: "row.item.conformityNo"
          }],
          attrs: {
            "type": "checkbox",
            "name": "conformityNo",
            "disabled": true
          },
          domProps: {
            "checked": Array.isArray(row.item.conformityNo) ? _vm._i(row.item.conformityNo, null) > -1 : (row.item.conformityNo)
          },
          on: {
            "change": function($event) {
              var $$a = row.item.conformityNo,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(row.item, "conformityNo", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(row.item, "conformityNo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(row.item, "conformityNo", $$c)
              }
            }
          }
        })]
      }
    }, {
      key: "conformityNA",
      fn: function(row) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (row.item.conformityNA),
            expression: "row.item.conformityNA"
          }],
          attrs: {
            "type": "checkbox",
            "name": "conformityNA",
            "disabled": true
          },
          domProps: {
            "checked": Array.isArray(row.item.conformityNA) ? _vm._i(row.item.conformityNA, null) > -1 : (row.item.conformityNA)
          },
          on: {
            "change": function($event) {
              var $$a = row.item.conformityNA,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(row.item, "conformityNA", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(row.item, "conformityNA", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(row.item, "conformityNA", $$c)
              }
            }
          }
        })]
      }
    }], null, false, 3105640627)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSave($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClean
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")]), _vm._v(" "), _vm._m(2)])])]) : _vm._e()])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro de uma FAV")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:history.go(-1)"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6160f02b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/fav/NovaFav.vue
// module id = 1978
// module chunks = 1